import type { TaskTimeAsignedTo } from '@/types/capacityTracker';
import { apiService } from './api';
import type { ConversationCard } from '@/types/dashboard';

class ReportService
{
  static async GetAllTeams(): Promise<any>
  {
    try
    {
      const response = await apiService.post(`TaskTimeTracking/GetAll`, undefined, { timeout: 0 });
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async GetAllAsignedTo(request: {
    Teams: string;
    GetTeamId: boolean;
    GetDepartmentId: boolean;
    GetPositionId: boolean;
    GetAllPeople: boolean;
  }): Promise<TaskTimeAsignedTo[]>
  {
    try
    {
      const response = await apiService.get<TaskTimeAsignedTo[]>(
        `TaskTimeTracking/GetAllAsigned?teams=${request.Teams}&getTeamId=${request.GetTeamId}&getDepartmentId=${request.GetDepartmentId}&getPositionId=${request.GetPositionId}&getAllPeople=${request.GetAllPeople}`,
        { timeout: 0 },
      );
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async GetAllProject(request: any): Promise<any>
  {
    try
    {
      const response = await apiService.post(`Project/GetSideMenuProjects`, request, { timeout: 0 });
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async GetLayers(): Promise<any>
  {
    try
    {
      const response = await apiService.get(`layer/getpersonlayers`, { timeout: 0 });
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async GetArtistCategories(): Promise<any>
  {
    try
    {
      const response = await apiService.post(`TaskTimeTracking/GetAllArtistCategory`, undefined, { timeout: 0 });
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async GetDepartments(): Promise<any>
  {
    try
    {
      const response = await apiService.post(`TaskTimeTracking/GetAllDepartments`, undefined, { timeout: 0 });
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async GetAllCard(): Promise<any>
  {
    try
    {
      const response = await apiService.post(`TaskTimeTracking/GetAllCard`, undefined, { timeout: 0 });
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async GetAllTimeTrack(request: any): Promise<any>
  {
    try
    {
      const response = await apiService.post(`TaskTimeTracking/GetAllTimeTrack`, request, {
        timeout: 0,
      });
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async GetCaptureTime(request: any): Promise<any>
  {
    try
    {
      const response = await apiService.post(`TaskTimeTracking/GetCaptureTime`, request, { timeout: 0 });
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async GetDashboardsByProjectIds(request: any): Promise<any>
  {
    try
    {
      const response = await apiService.get(
        `dashboard/GetDashboardsByProjectId?projectIds=${request}`,
        { timeout: 0 },
      );
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async GetMonthlyPerformanceReport(request: any): Promise<any>
  {
    try
    {
      const response = await apiService.post(`Notification/GetMonthlyPerformanceReport`, request, {
        timeout: 0,
      });
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async GetEfficiencyReport(request: any): Promise<any>
  {
    try
    {
      const response = await apiService.post(`TaskTimeTracking/GetEfficiency`, request, { timeout: 0 });
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async GetEfficiencyData(payload: {
    StartDate: string;
    DueDate: string;
    PersonId: string;
    WebUrl: string;
  }): Promise<any>
  {
    try
    {
      const response = await apiService.post(`Notification/GetEfficiencyReport`, payload, { timeout: 0 });
      return response;
    }
    catch (error)
    {
      console.error('Error getting efficiency data:', error);
      throw error;
    }
  }

  static async GetProductivityReport(request: any): Promise<any>
  {
    try
    {
      const response = await apiService.post(`TaskTimeTracking/GetProductivity`, request, { timeout: 0 });
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async GetCommentsList(_request: any): Promise<any>
  {
    try
    {
      const response = await apiService.get(`Attendance/GetCommentsList`, { timeout: 0 });
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async GetAttendanceReport(request: any): Promise<any>
  {
    try
    {
      const response = await apiService.post(`Attendance/GetAttendanceReport`, request, { timeout: 0 });
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async GetStatusList(_request: any): Promise<any>
  {
    try
    {
      const response = await apiService.get(`TaskTimeTracking/GetStatusOptions`, { timeout: 0 });
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async GetVacationRequestByIds(request: any): Promise<any>
  {
    try
    {
      const response = await apiService.post(
        `VacationsRequest/GetVacationRequestByPersonIds`,
        request,
        { timeout: 0 },
      );
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async GetHolidays(_request: any): Promise<any>
  {
    try
    {
      const response = await apiService.get(`VacationsRequest/GetHolidays`, { timeout: 0 });
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async SaveClockOutComment(request: any): Promise<any>
  {
    try
    {
      const response = await apiService.post(`Attendance/PostEditClockOutComment`, request, { timeout: 0 });
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async GetHireDate(request: any): Promise<any>
  {
    try
    {
      const response = await apiService.get(`VacationsRequest/GetHireDate?personId=${request}`, { timeout: 0 });
      return response;
    }
    catch (error)
    {
      console.error('Error setting sp:', error);
      throw error;
    }
  }

  static async GetEfficiencyAsignedTo(request: {
    teams: string;
    artistCategory: string;
    department: string;
    getAll: boolean;
  }): Promise<any[]>
  {
    try
    {
      const response = await apiService.get<any[]>(
        `TaskTimeTracking/GetAllAsigned?teams=${request.teams}&artistCategory=${request.artistCategory}&department=${request.department}&getAllInfo=${request.getAll}`,
        { timeout: 0 },
      );
      return response;
    }
    catch (error)
    {
      console.error('Error fetching efficiency assigned:', error);
      throw error;
    }
  }

  static async GetAssignmentReportFilter(request: { GroupByDetailId: number }): Promise<any[]>
  {
    try
    {
      const response = await apiService.post<any[]>(
        `TaskTimeTracking/GetAssignmentReportFilter`,
        request,
        { timeout: 0 },
      );
      return response;
    }
    catch (error)
    {
      console.error('Error fetching assignment filter:', error);
      throw error;
    }
  }

  static async GetAssignmentReport(request: any): Promise<any[]>
  {
    try
    {
      const response = await apiService.post<any[]>(
        `TaskTimeTracking/GetAssignmentReport`,
        request,
        { timeout: 0 },
      );
      return response;
    }
    catch (error)
    {
      console.error('Error fetching assignment report:', error);
      throw error;
    }
  }

  static async GetProjectsByConfigValueId(configValueId: number): Promise<any[]>
  {
    try
    {
      const response = await apiService.get<any[]>(
        `Project/GetProjectsByConfigValueId?configValueId=${configValueId}`,
        { timeout: 0 },
      );
      return response;
    }
    catch (error)
    {
      console.error('Error fetching projects by config:', error);
      throw error;
    }
  }

  static async GetETACostReport(request: { projectId: number }): Promise<any[]>
  {
    try
    {
      const response = await apiService.post<any[]>(`TaskTimeTracking/GetETACostReport`, request, { timeout: 0 });
      return response;
    }
    catch (error)
    {
      console.error('Error fetching ETA cost report:', error);
      throw error;
    }
  }

  static async GetPositions(): Promise<any[]>
  {
    try
    {
      const response = await apiService.get<any[]>(`Positions/GetPositions`, { timeout: 0 });
      return response;
    }
    catch (error)
    {
      console.error('Error fetching positions:', error);
      throw error;
    }
  }

  static async GetListPeopleBlob(): Promise<Blob>
  {
    try
    {
      const response = await apiService.get<Blob>(`Attendance/GetListPeople`, {
        responseType: 'blob',
        timeout: 0,
      });
      return response;
    }
    catch (error)
    {
      console.error('Error downloading list people:', error);
      throw error;
    }
  }

  static async GetArtistCaptureTime(request: {
    Teams: string;
    projectId: string;
    sideMenuId: string;
    DateTime: string;
    Duedate: string;
    timeZone: string;
  }): Promise<any[]>
  {
    try
    {
      const response = await apiService.post<any[]>(
        `TaskTimeTracking/ArtistGetCaptureTime`,
        request,
        { timeout: 0 },
      );
      return response;
    }
    catch (error)
    {
      console.error('Error fetching artist capture time:', error);
      throw error;
    }
  }

  static async GetConversationsForReportAssigment(request: {
    strConversationsIds: string;
  }): Promise<ConversationCard[]>
  {
    try
    {
      const response = await apiService.post<ConversationCard[]>(
        `Conversation/GetConversationsForReportAssigment`,
        request,
        { timeout: 0 },
      );
      return response;
    }
    catch (error)
    {
      console.error('Error fetching artist capture time:', error);
      throw error;
    }
  }
}

export default ReportService;
